import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal
} from "@angular/core";
import { LMFieldPickerSelectOptions, LMFieldPickerSelectResponse} from "@modal/field-picker/lm-field-picker";
import { LMFieldPickerService } from "@app/components";
import { LMErrorUtilService } from "@app/services";

@Component({
  selector:    'lm-field-picker-lookup',
  standalone: false,
  templateUrl: 'lm-field-picker-lookup.component.html',
  styleUrls:   [ 'lm-field-picker-lookup.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LMFieldPickerLookupComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() fieldPickerSelectOptions!: LMFieldPickerSelectOptions;
  @Input() fieldLabel = '';
  @Input() automationId = '';
  @Input() fieldPickerUrl = '';

  @Output() lookupValueChangedEvent: EventEmitter<string> = new EventEmitter<string>();

  fieldValue = signal('');

  constructor(
    private lmFieldPickerService: LMFieldPickerService,
    private lmErrorUtilService: LMErrorUtilService
  ) {
  }

  ngOnInit(): void {
    if (!this.fieldPickerSelectOptions) {
      return;
    }
  }

  ngAfterViewInit(): void {
    // todo
  }

  ngOnDestroy(): void {
    // todo
  }

  onLookupClick: SohoLookupClickFunction = (e, lookup) => {
    this.lmFieldPickerService.openFieldPickerDialog(this.fieldPickerSelectOptions, this.fieldPickerUrl, undefined as any)
      .subscribe({
        next: (response: LMFieldPickerSelectResponse) => {
          this.fieldValue.set(response.fieldName);
          this.lookupValueChangedEvent.emit(response.fieldName);
          console.log('response', [ response ]);
        },
        error: (error: any) => {
          const error2: LMError = { message: error.message, status: error.status, details: error.stack };
          this.lmErrorUtilService.handleUnexpectedError(error2);
        }
      });
  };

  public onValueChanged(event: any) {
    this.lookupValueChangedEvent.emit(event.currentTarget.value);
    console.log('onValueChanged', [ event ]);
  }
}
